document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[aria-controls][aria-haspopup="dialog"].pdp-trigger').forEach(function (trigger) {
    var modal = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!modal) return;

    // The modal can be nested inside an animated wrapper (motion-element) that applies
    // a CSS transform for its entrance animation. Any transformed ancestor becomes the
    // containing block for position:fixed children, which breaks full-viewport centering.
    // Move the modal to the end of <body> so it always centers on the whole page.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    trigger.addEventListener('click', function () {
      modal.classList.add('is-open');
    });

    var closeBtn = modal.querySelector('[data-pdp-modal-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        modal.classList.remove('is-open');
      });
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        modal.classList.remove('is-open');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        modal.classList.remove('is-open');
      }
    });
  });

  // "See all dimensions" jump-link: opens and scrolls to the Dimensions accordion.
  // Matches any link ending in #dims (e.g. the link pasted into the
  // product.metafields.custom.pdp_dimensions_bar metafield), and finds the
  // Dimensions accordion via its stable [data-dims-jump-target] attribute
  // (its real id is dynamic per block/section instance).
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href$="#dims"], a[href="#dims"]');
    if (!link) return;

    var target = document.querySelector('[data-dims-jump-target]');
    if (!target) return;

    e.preventDefault();

    if ('open' in target) {
      target.open = true;
    } else {
      target.setAttribute('open', '');
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  // Mobile tap feedback for the complementary-slider "Add" button.
  // Touch devices never fire :hover, and iOS Safari does not reliably apply
  // :active either, so a class is toggled on pointer events instead. Delegated
  // from document because product-recommendations re-renders the slider cards.
  var atcSelector = '.product__block--complementary .product-card__atc';
  var atcTapTimer;

  function clearAtcTap() {
    var tapped = document.querySelectorAll('.product-card__atc.is-tapping');
    if (!tapped.length) return;
    clearTimeout(atcTapTimer);
    // Hold the colour for a beat after the finger lifts so the tap is visible.
    atcTapTimer = setTimeout(function () {
      tapped.forEach(function (el) {
        el.classList.remove('is-tapping');
      });
    }, 180);
  }

  document.addEventListener(
    'pointerdown',
    function (e) {
      if (e.pointerType === 'mouse') return;
      var btn = e.target && e.target.closest ? e.target.closest(atcSelector) : null;
      if (!btn) return;
      clearTimeout(atcTapTimer);
      btn.classList.add('is-tapping');
    },
    { passive: true }
  );

  ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (evt) {
    document.addEventListener(evt, clearAtcTap, { passive: true });
  });
});